/* 我的-钱包-账单 */
<template>
  <div class="bill-box">
    <!-- 头部 -->
    <headerTop title="账单"></headerTop>
    <!-- 内容 -->
    <div class="content">
      <div class="content-header">
        <!-- 日期 -->
        <div class="content-header-l">
          <span
            class="left iconfont iconchangyongtubiao-xianxingdaochu-zhuanqu-"
            @click="changReduce"
          ></span>
          <div class="date">
            <span>{{year}}</span>
            <span>.</span>
            <span>{{month}}</span>
          </div>
          <span
            v-if="year >= currentYear && month >= currentMonth"
            class="right iconfont iconchangyongtubiao-xianxingdaochu-zhuanqu-1 right-active"
          ></span>
          <span
            v-else
            class="right iconfont iconchangyongtubiao-xianxingdaochu-zhuanqu-1"
            @click="changPlus"
          ></span>
        </div>
        <div class="content-header-r">
          <div class="expenditure">
            <span>支出</span>
            <span>{{ Math.abs(accountDetailTotal.total_expend) }}</span>
          </div>
          <div class="income">
            <span>收入</span>
            <span>{{ accountDetailTotal.total_income }}</span>
          </div>
        </div>
      </div>
      <div class="none-box"></div>
      <div class="record">
        <van-list
          v-model="dataLoading"
          :finished="dataFinished"
          finished-text="没有更多了"
          @load="getLoadData"
        >
          <div
            class="record-item"
            v-for="item in dataList"
            :key="item.id"
            @click="toBillDetail(item)"
          >
            <p class="record-item-title">
              <label>
                {{ item.subject }}
                {{ item.is_personal_commission === 1 && item.personal_commission_flag === 0 ? `(${item.personal_commission_phone}未达标)` : '' }}
              </label>
              <span
                v-if="item.bill_category === 'commission' || item.bill_category === 'level_award'"
                class="iconfont iconyoujiantou"
              ></span>
            </p>
            <div class="record-item-content">
              <div class="data">{{ item.create_time.substring(0, 16) }}</div>
              <div
                :class="item.amount > 0 ? 'money-active' : 'money'"
              >{{ item.amount > 0 ? `+${item.amount}` : item.amount}}</div>
            </div>
          </div>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
import headerTop from "@/components/common/headerTop.vue";
import accountApi from "@/api/accountApi";

export default {
  data() {
    return {
      firstData: true,
      year: "",
      month: "",
      currentMonth: new Date().getMonth() + 1,
      currentYear: new Date().getFullYear(),
      dataList: [],
      dataLoading: false,
      dataFinished: false,
      dataTotalPage: 1,
      dataPage: 1,
      dataPageSize: 10,
      accountDetailTotal: {
        total_expend: 0,
        total_income: 0
      }
    };
  },
  mounted() {
    this.obtainDate();
    let data = {
      year: this.year,
      month: this.month
    };
    accountApi.accountDetailTotal(data).then(res => {
      this.accountDetailTotal = res;
    });
  },
  methods: {
    getLoadData() {
      // 判断是不是获得滚动数据
      if (!this.firstData) return;
      this.dataLoad(true);
    },
    // 请求接口调用数据
    dataLoad(boolean = true) {
      let data = {
        year: this.year,
        month: this.month,
        page: this.dataPage,
        page_size: this.dataPageSize
      };
      accountApi.accountDetail(data).then(res => {
        // Java 契约：列表在 data（PHP 是 datas），总页数是 pageCount（PHP 是 last_page）
        const tempData = res.data || [];
        if (boolean) {
          console.log(1);
          this.dataList = this.dataList.concat(tempData);
        } else {
          console.log(0);
          this.dataList = tempData;
           this.firstData = true;
        }
        this.dataTotalPage = res.pagination ? res.pagination.pageCount : 1;
        this.dataLoading = false;
        if (this.dataPage >= this.dataTotalPage) {
          this.dataFinished = true;
        }
        this.dataPage++;
      });
    },

    datas() {
      if (parseInt(this.month) < 10) {
        this.month = "0" + this.month;
      } else {
        this.month = this.month;
      }
    },
    // 获取日期
    obtainDate() {
      let date = new Date();
      this.year = date.getFullYear();
      this.month = date.getMonth() + 1;
      this.datas();
    },
    // 加减日期
    changReduce() {
      this.month = parseInt(this.month) - 1;
      this.datas();
      if (this.month < "01") {
        this.year = this.year - 1;
        this.month = "12";
      }
      this.changeDataLoad();
    },
    changPlus() {
      let year = new Date().getFullYear();
      let month = new Date().getMonth() + 1;
      if (this.month >= month && this.year >= year) {
      } else {
        this.month = parseInt(this.month) + 1;
        this.datas();
        if (this.month > "12") {
          this.year = this.year + 1;
          this.month = "01";
        }
        this.changeDataLoad();
      }
    },
    changeDataLoad() {
      this.dataList = [];
      this.dataLoading = false;
      this.dataFinished = false;
      this.dataTotalPage = 1;
      this.dataPage = 1;

      let data = {
        year: this.year,
        month: this.month
      };
      accountApi.accountDetailTotal(data).then(res => {
        this.accountDetailTotal = res;
      });

      this.firstData = false;
      this.dataLoad(false);
    },
    toBillDetail(item) {
      // 判断个人业绩提成
      if (item.bill_category === "commission") {
        this.$router.push({
          name: "billDetail",
          query: {
            businessId: item.business_id,
            billCategory: item.bill_category,
            createTime: item.create_time,
            price: item.price
          }
        });
      } else if (item.bill_category === "level_award") {
        this.$router.push({
          name: "billDetail",
          query: {
            businessId: item.business_id,
            billCategory: item.bill_category,
            createTime: item.create_time,
            price: item.price
          }
        });
      }
    }
  },
  components: {
    headerTop
  }
};
</script>

<style lang="less" scoped>
.bill-box {
  .content-header {
    display: flex;
    justify-content: space-between;
    height: 68px;
    align-items: center;
    padding: 0 15px;
    .content-header-l {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #1d1d1d;
      .date {
        margin: 0 10px;
      }
      .right-active {
        color: #cccccc;
      }
    }
    .content-header-r {
      font-size: 14px;
      color: #333333;
      display: flex;
      .expenditure {
        & span:nth-child(2) {
          color: #37a851;
        }
      }
      .income {
        margin-left: 10px;
        & span:nth-child(2) {
          color: #ea2c2c;
        }
      }
    }
  }
  .none-box {
    background: #f8f8f8;
    height: 10px;
    width: 100%;
  }
  .record {
    padding: 0 15px;
    .record-item {
      height: 87px;
      width: 100%;
      border-bottom: 1px solid #e4e4e4;
      overflow: hidden;
      .record-item-title {
        position: relative;
        margin-top: 17px;
        label {
          width: 85vw;
          display: block;
          overflow: hidden; /*自动隐藏文字*/
          text-overflow: ellipsis; /*文字隐藏后添加省略号*/
          display: -webkit-box;
          -webkit-line-clamp: 1; /*想要显示的行数*/
          -webkit-box-orient: vertical;
        }
        .iconfont {
          font-size: 14px;
          position: absolute;
          top: 0;
          right: 0;
          color: #999999;
        }
      }
      .record-item-content {
        margin-top: 7px;
        display: flex;
        justify-content: space-between;
        .data {
          font-size: 14px;
          color: #999999;
        }
        .money-active {
          font-size: 18px;
          color: #ea2c2c;
        }
        .money {
          font-size: 18px;
          color: #37a851;
        }
      }
    }
  }
}
</style>
